import ISmartPlayerVideoPlayer from '../../types/ISmartPlayerVideoPlayer';
import IVideoPlayer from '../../types/IVideoPlayer';

export default class implements IVideoPlayer {
   player: ISmartPlayerVideoPlayer;
   isDisposed: boolean;
   handlers: any[];

   constructor(smartPlayerMediaInterface: ISmartPlayerVideoPlayer) {
      this.player = smartPlayerMediaInterface;
      this.isDisposed = false;
      this.handlers = [];
   }

   getCurrentTime() {
      return this.player.currentTime;
   }

   setCurrentTime(time: number) {
      this.player.currentTime = time;
   }

   getDuration() {
      return this.player.duration;
   }

   on(event: string, handler: (e: any) => void) {
      this.player.addEventListener(event, handler);
      this.handlers.push(event, handler);
   }

   dispose() {
      this.isDisposed = true;
      this.handlers.forEach(({event, handler}) => {
         this.player.removeEventListener(event, handler);
      });
   }

   getIsDisposed() {
      return this.isDisposed;
   }

   play() {
      this.player.play();
   }

   pause() {
      this.player.pause();
   }

   setScrubbing(val: boolean) {
      this.player.scrubbing = val;
   }

   setVolume(vol: number) {
      this.player.volume = vol;
   }

   one(event: string, handler: () => void) {
      const listener = () => {
         if (!this.isDisposed) {
            handler();
         }
         this.player.removeEventListener(event, listener);
      };

      this.player.addEventListener(event, listener);
   }

   getIsPaused() {
      return this.player.paused;
   }

   getIsSeeking() {
      return this.player.seeking;
   }

   getIsNullInstance() {
      return false;
   }

   getSrc() {
      return this.player.src;
   }

   setSrc(source: string) {
      this.player.src = source;
   }
}
